/**
 * External dependencies
 */
import axios from "axios";
import _forOwn from 'lodash.forown';

const instance = axios.create({
  baseURL: process.env.REACT_APP_LEVY_ECRACKER_API_URL,
  timeout: 30000
});

/**
 * Get Random Joke
 * 
 * Returns a random joke from the back-end API.
 * 
 * @returns {Promise}
 */
export const getRandomJoke = () => {
  return instance.get( '/jokes/random' );
};

/**
 * Submit Form Data
 * 
 * Submits the user filled out form fields to the back-end API.
 * 
 * @param {Object} data Form data to send to the back-end API. 
 * @returns {Promise}
 */
export const submitFormData = ( data => {
  const formData = new FormData();
  _forOwn( data, ( value, key ) => {
    formData.append( key, value );
  } );

  return instance.post( '/entries/submit', formData );
});

/**
 * Check Venue
 * 
 * Checks the slug passed is for a valid venue by contacting the back-end API.
 * 
 * @param {String} slug The slug passed as a venue query string. 
 * @returns {Promise}
 */
export const check_venue = ( slug => {
  return instance.get( `/venues/${ slug }` );
});